/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-misused-promises */

import Image from 'next/image'
import { onDownloadApp } from '@components/MainWidget/common/helper'
import { getWhatsAppChallanProperties } from '@factories/getWhatsAppChallanProperties'
import { formatAndCombineTextArray } from '@utils/combineText'
import styles from './WhatsappChallanNewFlow.module.scss'
import { appRedirectionMock } from './challan.config'
import {
  evaluatingCarImageSrc,
  greenTickSrc,
  guidelineImageSrc,
  guidelineText,
  infoText,
  nonVahanStateIconSrc,
  stateReplaceText,
} from './constants'
import { IAppRedirectComp } from './interfaces'
import { getChallanStatus } from './helper'

const AppRedirectComp = ({
  utmLead,
  regNum,
  widgetType,
  phoneNo,
  stateName,
  isNonVahanState,
  numOfChallans = 0,
  vehicleData,
}: IAppRedirectComp) => {
  const challanStatus = getChallanStatus(numOfChallans, isNonVahanState)
  const extraEventProperties = getWhatsAppChallanProperties(isNonVahanState, utmLead, stateName)

  return (
    <div className={styles.appRedirectionContainer}>
      <div className={`${styles.mainContainer} ${isNonVahanState ? styles.otpNeeded : ''}`}>
        {isNonVahanState && (
          <Image src={nonVahanStateIconSrc} alt="OTP Required" width={64} height={64} className={styles.otpImage} />
        )}
        <div className={styles.heading}>
          {appRedirectionMock?.[challanStatus]?.heading?.replace(stateReplaceText, stateName)}
        </div>
        {!isNonVahanState && (
          <div className={styles.middleSection}>
            <div className={styles.perksOnApp}>
              {appRedirectionMock?.[challanStatus]?.perks?.map((perk, index) => (
                <div className={styles.perkContent} key={index}>
                  <Image src={greenTickSrc} alt="Green Tick" width={20} height={20} className={styles.greenTick} />
                  <span className={styles.perkText}>{perk}</span>
                </div>
              ))}
            </div>
            <Image src={evaluatingCarImageSrc} alt="App Download" width={80} height={80} className={styles.perkImage} />
          </div>
        )}
        <div className={styles.buttonWithInfo}>
          <button
            type="button"
            className={styles.redirectLink}
            onClick={() =>
              onDownloadApp({
                regNo: regNum,
                widgetType,
                phone: phoneNo,
                vehicleData,
                ctaText: appRedirectionMock?.[challanStatus]?.cta,
                segmentEventCommonProperties: extraEventProperties,
              })
            }>
            <div className={styles.redirectButton}>{appRedirectionMock?.[challanStatus]?.cta}</div>
          </button>
          {isNonVahanState && (
            <span className={styles.infoLabel}>
              {formatAndCombineTextArray(infoText, { [stateReplaceText]: stateName })}
            </span>
          )}
        </div>
      </div>
      {isNonVahanState && (
        <div className={styles.guideline}>
          <div className={styles.guidelineImage}>
            <Image src={guidelineImageSrc} alt="Guideline Image" width={16} height={16} />
          </div>
          <span className={styles.text}>
            {formatAndCombineTextArray(guidelineText, { [stateReplaceText]: stateName })}
          </span>
        </div>
      )}
    </div>
  )
}

export default AppRedirectComp
